export enum StatusColor {
  RED = 'red',
  ORANGE = 'orange',
  BLUE = 'blue',
  VIOLET = 'violet',
  GREEN = 'green',
  GREY = 'grey',
  BLACK = 'black',
  WHITE = 'white',
  COLOR_REGEX = "^#(?:[0-9a-fA-F]{3}){1,2}$",
}
